import Logout from './Logout-view';

export default Logout;
